import { EProductSizes } from '../../../model/enums';
import miniImg from '../../../assets/images/sizes/mini/card.webp';
import standardImg from '../../../assets/images/sizes/standard/card.webp';

import styles from './styles.module.scss';

type Props = {
  type?: EProductSizes;
  seleted: boolean;
  cardData: Record<string, any>;
};

const PatchInfoBySizes = {
  [EProductSizes.mini]: {
    title: 'Mini',
    info: 'Ideal for pets less than 3kg',
    sizes: '30cm x 40cm',
    prevPrice: 29.95,
    currentPrice: 28.45,
    imgSrc: miniImg,
  },
  [EProductSizes.standard] : {
    title: 'Standard',
    info: 'Ideal for pets less than 8kg',
    sizes: '40cm x 60cm',
    prevPrice: 34.95,
    currentPrice: 33.2,
    imgSrc: standardImg,
  },
};

const CardItem = ({ type = EProductSizes.standard, seleted, cardData }: Props) => (
  <div className={`${styles.cardItem} ${seleted ? styles.selected : ''}`}>
    <div className={styles.imgWrapper}>
      <img src={PatchInfoBySizes[type].imgSrc} alt="" />
    </div>
    <div className={styles.infoWrapper}>
      <div className={styles.cardTitle}>{PatchInfoBySizes[type].title}</div>
      <div className={styles.info}>{PatchInfoBySizes[type].info}</div>
      <div className={styles.sizes}>{PatchInfoBySizes[type].sizes}</div>
      <div className={styles.priceWrapper}>
        <span className={styles.prevPrice}>€{cardData?.price}</span>
        <span className={styles.currentPrice}>
          €{cardData?.subscribe_price}
        </span>
      </div>
    </div>
  </div>
);

export default CardItem;
